module.exports = __webpack_public_path__ + "img/certificate1.c6a59d17.jpg";